import processor from './processor';
import { UpscalePanel, wrapImageOverlayer } from './components';
import { upscaleParamsHandler, upscaleResultHandler } from './processor/config';
import { enterDerivativeFromElement } from '../derivative';
import { toolTypes } from '../../constants';
import { translate } from '@shakkerai/util-i18n';

export default {
  setup: async ({ app }) => {
    // 注册一个局部重绘处理器
    app.extension.registerProcessor(toolTypes.upscale.name, processor);

    // 对现有图片组件进行包装，提供画布内编辑能力
    app.extension.wrapElement('image', { overlayer: wrapImageOverlayer });

    // 注册一个局部重绘生成参数处理器和结果处理器
    app.modules.generator.methods.registerGenerateParamsHandler(toolTypes.upscale.name, upscaleParamsHandler);
    app.modules.generator.methods.registerGenerateResultHandler(toolTypes.upscale.name, upscaleResultHandler);

    // 注册一个局部重绘图片工具类型
    app.extension.registerElementTool({
      name: toolTypes.upscale.name,
      isAI: true,
      label: translate('imagetool_upscale'),
      preventCanvasUndoRedo: true,
      handler: ({ selection }) => {
        if (selection.length !== 1) return;
        if (selection[0].split('-')[1] !== 'image') return;

        enterDerivativeFromElement(toolTypes.upscale.name, selection[0], { forceCreate: true });
      },
    });

    // 注册局部重绘右侧面板组件
    app.extension.registerComponent('right_panel', {
      Component: UpscalePanel,
      config: {
        name: toolTypes.upscale.name,
      },
    });
  },
};
